import { SAVE_REPORT_CONFIGURATION } from "../../../../config/constants";
import { withType } from "../../../utils/actionOperations";
import { ApiBase } from "../../../utils/apiBase";
import { getProjectIdAndOrgId } from "../../../utils/apiUtils";
import { encodeContents } from "../../../utils/encryptionUtils";
import {
  RENDER_PDF_SAVE_STARTED,
  RENDER_PDF_SAVE_SUCCESS,
  RENDER_PDF_SAVE_FAILED,
} from "../../constants";




export const saveReportData = (payload, callback) => {
  const apiBaseInstance = new ApiBase();
  return (dispatch, getState) => {
    dispatch(withType(RENDER_PDF_SAVE_STARTED, {}));
    let updatedContent = {}
    if (getState().RenderPdfReducer.reportType === "standard") {
      let data = getState().RenderPdfReducer.data;
      let encodedContents = encodeContents(JSON.stringify(data))
      updatedContent.reportConfiguration = encodedContents
    }
    else {
      let data = getState().RenderPdfReducer.trendData;
      let encodedContents = encodeContents(JSON.stringify(data))
      updatedContent.trendReportConfiguration = encodedContents
    }



    apiBaseInstance.instance
      .post(SAVE_REPORT_CONFIGURATION, { ...updatedContent, ...getProjectIdAndOrgId(payload), ...payload })
      .then((response) => { dispatch(withType(RENDER_PDF_SAVE_SUCCESS, {})); })
      .catch(err => {
        dispatch(withType(RENDER_PDF_SAVE_FAILED, {
          error: err
        }));
      });
  };
};